export default __webpack_public_path__ + "static/media/Naganath S.ac606ee7.png";